import { IEmployee } from "@gtmhub/employees";
import { ITeam } from "@gtmhub/teams";
import { IdMap } from "@gtmhub/util";

export function createEmployeeAndTeamMap(employee: IEmployee, teams: ITeam[]): IdMap<IEmployee | ITeam> {
  const map: IdMap<IEmployee | ITeam> = {};
  map[employee.id] = employee;
  teams.forEach((team) => (map[team.id] = team));
  return map;
}
